// extracted by mini-css-extract-plugin
export default {"removeBtn":"RemoveAddressBtn_removeBtn__3M821"};